module.exports = __webpack_public_path__ + "img/a215_device_halo.8c692087.png";